import api from '@/services/api/auth.api'

export default {
  state: {
    token: null,
    user: null
  },
  mutations: {
    setCustomerId (state, payload) {
      state.customerId = payload
    },
    setToken (state, payload) {
      state.token = payload
    },
    setUser (state, payload) {
      state.user = payload
    }
  },
  actions: {
    loginUser ({ commit }, payload) {
      return api.loginUser(payload).then(({ data }) => {
        commit('setOrganization', data.organization)
        commit('setToken', data.token)
        commit('setUser', data.user)
      })
    },
    logoutUser ({ commit }) {
      return api.logoutUser().then(() => {
        commit('setToken', null)
        commit('setUser', null)
      })
    },
    async signUpUser ({ commit }, payload) {
      const { data } = await api.signUpUser(payload)
      if (data.status === 'succeeded') {
        commit('setOrganization', data.organization)
        commit('setToken', data.token)
        commit('setUser', data.user)
      }
      return data
    }
  },
  getters: {
    getToken (state) {
      return state.token
    },
    isAuthenticated (state) {
      return state.user
    }
  }
}
